import * as types from './types';

const selectProduct = product => {
  return {
    type: types.SET_SELECTED_PRODUCT,
    payload: product
  };
};

const setSelectedLocation = locationId => {
  return {
    type: types.SET_SELECTED_LOCATION,
    payload: locationId
  };
};

const getEcommerceUser = () => {
  return {
    type: types.GET_ECOMMERCE_USER,
    meta: {
      async: true,
      api: 'ecommerce',
      path: '/ecommerce/api/v1/users',
      headers: { 'X-NAVENT-APP': 'publicador' },
      method: 'GET'
    }
  };
};

const getProductTaxes = (userId, query) => {
  return {
    type: types.GET_PRODUCT_TAXES,
    meta: {
      async: true,
      api: 'ecommerce',
      path: `/ecommerce/api/v1/users/${userId}/taxes`,
      headers: { 'X-NAVENT-APP': 'publicador' },
      method: 'GET',
      query
    }
  };
};

const updateProductTaxes = (body, query) => {
  return {
    type: types.UPDATE_PRODUCT_TAXES,
    meta: {
      async: true,
      api: 'ecommerce',
      path: `/ecommerce/api/v1/users/taxes`,
      headers: { 'X-NAVENT-APP': 'publicador' },
      method: 'POST',
      query,
      body
    }
  };
};

const getLocationLevel = (locationId = '') => {
  return {
    type: types.GET_LOCATION_LEVEL,
    meta: {
      async: true,
      api: 'ecommerce',
      path: '/ecommerce/api/v1/locations/children',
      headers: { 'X-NAVENT-APP': 'publicador' },
      method: 'GET',
      query: { location: locationId }
    }
  };
};

const setPaymentLoading = (status = false) => {
  return {
    type: types.SET_PAYMENT_LOADER,
    payload: status
  };
};

const createInactiveOrder = ({ userType = 'particular', productIds = [], postingId }) => ({
  type: types.CREATE_INACTIVE_ORDER,
  meta: {
    async: true,
    api: 'ecommerce',
    path: '/ecommerce/api/v1/orders',
    headers: { 'X-NAVENT-APP': 'publicador' },
    method: 'POST',
    query: postingId,
    body: {
      productIds,
      userType
    }
  }
});

const setTaxConditions = payload => {
  return {
    type: types.SET_TAX_CONDITIONS,
    payload
  };
};

export {
  selectProduct,
  getEcommerceUser,
  getProductTaxes,
  updateProductTaxes,
  getLocationLevel,
  setSelectedLocation,
  setPaymentLoading,
  createInactiveOrder,
  setTaxConditions
};
